/* ==========================================================================
   Zapatos Obi — product-zoom.js
   Zoom EN EL MISMO recuadro de la foto (sin caja de luz / pantalla completa):
   - Escritorio (ratón): al pasar por encima, la imagen se amplía y sigue al
     cursor dentro de su propio contenedor (efecto lupa).
   - Táctil: se mantiene el carrusel deslizable (sin zoom, para no romper el swipe).
   El carrusel de puntos (móvil/tablet) se gestiona en el segundo bloque.
   ========================================================================== */
(function () {
  'use strict';

  var ZOOM = 2.3;

  /* Solo con ratón de verdad (en táctil mantenemos el carrusel deslizable) */
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  /* El origen del zoom se calcula sobre el RECUADRO (no sobre la imagen, que al
     estar escalada devuelve un rect distinto) para que la lupa siga al cursor. */
  function setOrigin(img, e) {
    var box = img.closest('.product-gallery__item') || img.parentElement;
    var r = box.getBoundingClientRect();
    var x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
    var y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
    img.style.transformOrigin = x + '% ' + y + '%';
  }

  gallery.addEventListener('mouseover', function (e) {
    var img = e.target.closest('.product-gallery__img');
    if (!img || img.tagName !== 'IMG') return;
    setOrigin(img, e);
    img.style.transform = 'scale(' + ZOOM + ')';
    img.classList.add('is-zoomed');
  });

  gallery.addEventListener('mousemove', function (e) {
    var img = e.target.closest('.product-gallery__img');
    if (!img || img.tagName !== 'IMG' || !img.classList.contains('is-zoomed')) return;
    setOrigin(img, e);
  });

  gallery.addEventListener('mouseout', function (e) {
    var img = e.target.closest('.product-gallery__img');
    if (!img || img.tagName !== 'IMG') return;
    img.classList.remove('is-zoomed');
    img.style.transform = '';
    img.style.transformOrigin = '';
  });
})();

/* Puntos del carrusel de la galería (móvil/tablet) */
(function () {
  'use strict';
  var trackEl = document.querySelector('[data-product-gallery]');
  var dotsEl = document.querySelector('[data-gallery-dots]');
  if (!trackEl || !dotsEl) return;
  var dots = Array.prototype.slice.call(dotsEl.querySelectorAll('[data-gallery-dot]'));

  function sync() {
    if (!trackEl.clientWidth) return;
    var i = Math.round(trackEl.scrollLeft / trackEl.clientWidth);
    dots.forEach(function (d, n) {
      d.classList.toggle('is-active', n === i);
    });
  }
  trackEl.addEventListener('scroll', sync, { passive: true });
  dots.forEach(function (d, n) {
    d.addEventListener('click', function () {
      trackEl.scrollTo({ left: n * trackEl.clientWidth, behavior: 'smooth' });
    });
  });
})();
